let wid = $WR.define('cheetahApplication/form/DesignerVueComp', [], function(require, exports, module) {
  const HTML = `
  <div class="x-field-editor">
    <div class="form-group"><label>域名称</label>
        <div class="controls"><input class="form-control" name="name"></div>
    </div>
    <div class="form-group"><label>模板</label>
        <div class="controls">
            <div style="height: 120px; border: 1px solid #e5e6e7;">
                <script data-bind="template" data-bind-type="widget" type="text/plain">
                    {xtype: 'CodeEditor', lang: 'HTML', isFormField: false, showLineNumbers: true}
                </script>
            </div>
        </div>
    </div>
    <div class="form-group"><label>脚本</label>
        <div class="controls">
            <div style="height: 120px; border: 1px solid #e5e6e7;">
                <script data-bind="script" data-bind-type="widget" type="text/plain">
                    {xtype: 'CodeEditor', lang: 'Javascript', isFormField: false, showLineNumbers: true}
                </script>
            </div>
        </div>
    </div>
    <div class="form-group"><label>样式</label>
        <div class="controls">
            <div style="height: 120px; border: 1px solid #e5e6e7;">
                <script data-bind="css" data-bind-type="widget" type="text/plain">
                    {xtype: 'CodeEditor', lang: 'CSS', isFormField: false, showLineNumbers: true}
                </script>
            </div>
        </div>
    </div>
</div>
  `;
  var WidgetClass = require('cheetahApplication/form/VueComp');
  let Comp = MW.extend(require('designer/form/default/Base'), {
    defaults: {
      xtype: 'VueComp',
      label: 'Vue组件',
      xtypeName: 'Vue组件',
      isFormField: false
    },
    _getTpl: function() {
      return $(HTML);
    },
    getTargetWidgetClass: function() {
      return WidgetClass;
    }
  });

  module.exports = Comp;

});
$WR.defineType({
  id: wid,
  xtype: 'DesignerVueComp',
  designer: ''
});

wid = $WR.define('cheetahApplication/form/VueComp', [], function(require, exports, module) {

  let Comp = MW.extend(require('Container'), {
    constructor: function(config, owner) {
      Comp.superclass.constructor.apply(this, arguments);
    },
    _render(renderTo,edit){
      let me=this;
      let dd=this.$dd || {};
      let mixin;
      if(dd.script){
        let script=`(function(){
              var $obj;

              ${dd.script}

              return $obj
            })()`;
        mixin=eval(script);
      }
      let formData
      let isRender=me.$form && _.isFunction(me.$form.getValue) //是渲染时而不是拖到表单设计器里面的时候
      if(isRender){
        formData=me.$form.getValue()
        me.$form.on("change",function(form,field){
          if(field.xtype==='list')return;
          let name=field.getName()
          if(name && _.isFunction(field.getValue)){
            oldFormData[name]=field.getValue(); //把值直接写入旧值里面，让他不会又更新回表单那边
            comp?comp.$set(formData,name,field.getValue()):formData[name]=field.getValue()
          }
        });
      }else{
        formData={}
      }
      let oldFormData=_.clone(formData)
      let debounceSetFormValue=_.debounce((newValue)=>{
        if(isRender){
          let changeValues=_(newValue).toPairs().filter(p=>oldFormData[p[0]]!==p[1]).fromPairs().value()
          if(!_.isEmpty(changeValues)){
            me.$form.setValue(changeValues);
            oldFormData=_.assign(oldFormData,changeValues)
          }
        }
      },100);
      let comp=PF.createVue({
        mixins:mixin?[mixin]:undefined,
        template:dd.template || "<div>模板组件</div>",
        data(){
          return {
            // form:me.$form,
            // field:me,
            formData:formData
          }
        },
        method:{
          getThisField(){
            return me
          },
          getForm(){
            return me.$form
          }
        },
        watch:{
          formData:{
            deep:true,
            handler(newValue){
              debounceSetFormValue(newValue)
            }
          }
        }
      });
      me.vueComp=comp;
      return $(comp.$mount().$el);
    },
    _afterRender(){
      Comp.superclass._afterRender.apply(this, arguments);
      setTimeout(()=>{
        let css=this.getDD().css;
        if (css) {
          this.cssEl=$("<style type='text/css'></style>").html(css).insertBefore(this.el[0]);
        }
      },0);
    },
    _afterDestroy(){
      Comp.superclass._afterDestroy.apply(this, arguments);
      if(this.cssEl)this.cssEl.remove()
    }
  });
  module.exports = Comp;
});

$WR.defineType({
  id: wid,
  xtype: 'VueComp',
  designer: 'DesignerVueComp'
});



// WEBPACK FOOTER //
// ./src/common/formWidget/vueComp.js